<div class="flex flex-col">
  <h2 class="text-xl font-semibold">Scan</h2>
  <div class="flex flex-row justify-center items-center text-sm m-2 rounded border border-1 border-solid p-4 bg-accent-200 text-accent-200-contrast">
    <i class="fa-regular fa-barcode-scan mr-4 fa-2x"></i>
    <span>Bitte scannen Sie einen Barcode</span>
  </div>
  <div class="soft-label top mt-4">Verlauf</div>
  <soft-scan-history class="max-h-[40vh] overflow-auto" (scanSelect)="onSelectScan($event)"></soft-scan-history>
</div>
